import { createContext } from "react";

export const ThemeData = createContext();
